var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{attrs:{"name":_vm.name,"id":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }